"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ItemActionCell = void 0;
const react_1 = __importDefault(require("react"));
const DeleteItemAction_1 = require("../actions/DeleteItemAction");
const ItemActionCell = (props) => {
    return (react_1.default.createElement("div", null, !props.isResource && props.editable && (react_1.default.createElement(DeleteItemAction_1.DeleteItemAction, { item: props.item, onDelete: props.onItemDelete }))));
};
exports.ItemActionCell = ItemActionCell;
